import {
  ChallengeClassicType,
  ChallengeDealType,
  ChallengeListType,
  ChallengePhotoType,
  ChallengePhaseBeforeDiffusion,
  ChallengePhaseBeforeSignIn,
  ChallengePhaseDuringSignIn,
  ChallengePhaseBeforeChallenge,
  ChallengePhaseDuringChallenge,
  ChallengePhaseAfterChallenge,
  ChallengePhaseAfterDiffusion,
  ChallengePhotoStatusRefused,
  ChallengePhotoStatusValidated,
  ChallengePhotoStatusWaiting,
  GoalByProfileType,
  GoalCustomType,
  GoalGenericType,
  GoalResultType,
} from 'interfaces';

export const CHALLENGE: {
  CLASSIC: ChallengeClassicType;
  DEAL: ChallengeDealType;
  LIST: ChallengeListType;
  PHOTO: ChallengePhotoType;
} = Object.freeze({
  CLASSIC: 'Classic',
  DEAL: 'Deal',
  LIST: 'List',
  PHOTO: 'Photo',
});

export const CHALLENGE_PHASE: {
  BEFORE_DIFFUSION: ChallengePhaseBeforeDiffusion;
  BEFORE_SIGN_IN: ChallengePhaseBeforeSignIn;
  DURING_SIGN_IN: ChallengePhaseDuringSignIn;
  BEFORE_CHALLENGE: ChallengePhaseBeforeChallenge;
  DURING_CHALLENGE: ChallengePhaseDuringChallenge;
  AFTER_CHALLENGE: ChallengePhaseAfterChallenge;
  AFTER_DIFFUSION: ChallengePhaseAfterDiffusion;
} = Object.freeze({
  BEFORE_DIFFUSION: 'BEFORE_DIFFUSION',
  BEFORE_SIGN_IN: 'BEFORE_SIGN_IN',
  DURING_SIGN_IN: 'DURING_SIGN_IN',
  BEFORE_CHALLENGE: 'BEFORE_CHALLENGE',
  DURING_CHALLENGE: 'DURING_CHALLENGE',
  AFTER_CHALLENGE: 'AFTER_CHALLENGE',
  AFTER_DIFFUSION: 'AFTER_DIFFUSION',
});

export const PHASES_ORDER = [
  CHALLENGE_PHASE.BEFORE_SIGN_IN,
  CHALLENGE_PHASE.DURING_SIGN_IN,
  CHALLENGE_PHASE.BEFORE_CHALLENGE,
  CHALLENGE_PHASE.DURING_CHALLENGE,
  CHALLENGE_PHASE.AFTER_CHALLENGE,
];

export const GOAL: {
  BY_PROFILE: GoalByProfileType;
  CUSTOM: GoalCustomType;
  GENERIC: GoalGenericType;
  RESULT: GoalResultType;
} = Object.freeze({
  BY_PROFILE: 'ByProfile',
  CUSTOM: 'Custom',
  GENERIC: 'Generic',
  RESULT: 'Result',
});

export const RESULT_STATUS: {
  REFUSED: ChallengePhotoStatusRefused;
  VALIDATED: ChallengePhotoStatusValidated;
  WAITING: ChallengePhotoStatusWaiting;
} = Object.freeze({
  REFUSED: 'refused',
  VALIDATED: 'validated',
  WAITING: 'waiting',
});
